export default {
	"order.NoRelevantOrderInformationYet": "还没有相关订单信息",
	"order.TradingClosed": "交易关闭",
	"order.YouHaveSuccessfullyAppliedPleaseCheckTheOrderStatusLater": "您已成功申请，请稍后查看订单状态",
	"order.TheSystemIsDeserted": "系统开小差啦！",
	"order.SignUpAndPayNow": "立即签约支付",
	"order.ApplyForADeduction": "申请扣款",
	"order.callOfficial": "叫叫官方",
	"order.ThisTimeYouOnlyNeedToPayTheTransferFee": "本次仅需支付转单费用：",
	"order.growBeans": "成长豆",
	"order.OrderHasBeenTransferred": "已转单",
	"order.total": "共计：",
	"order.openRecord": "开通记录",
	"order.ChangeAddress": "修改地址",
	"order.fillInTheAddress": "填写地址",
	"order.ViewLogistics": "查看物流",
	"order.ImmediatePayment": "立即付款",
	"order.loadMore": "加载更多",
	"order.noMore": "没有更多了",
	"order.hint": "提示",
	"order.understood": "知道了",
	"order.ToPayForTheOrderPleasePayInTheOrderLogisticsOfTheCallOfficialAccount": "支付该订单请在【叫叫】公众号的订单物流中进行支付",
	"order.PleaseEnsureThatYourContractAccountBalanceIsSufficientBeforeMakingADeductionApplication": "请保障您的签约账户余额充足后再进行扣款申请",
	"order.Cancel": "取消"
}